<template v-slot:header>
  <header
    :class="$style.header"
  >
    <HeadingLarge>{{ title }}</HeadingLarge>
    <ParagraphBody>
      <slot />
    </ParagraphBody>
  </header>
</template>

<script>
import { HeadingLarge, ParagraphBody } from '@jumpcloud/ui-components';

export default {
  name: 'SectionHeader',

  components: {
    HeadingLarge,
    ParagraphBody,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style module>
.header {
  border-bottom: var(--jc-border);
  margin-bottom: var(--jc-spacer-medium);
  padding-bottom: var(--jc-spacer-medium);
}
</style>
